import { createFileRoute } from '@tanstack/react-router';
import { SwAdmin } from '@/features/smart-working/SwAdmin';

export const Route = createFileRoute('/_app/admin/smart-working-config')({ component: SwAdmin });

// Admin policy smart working: smart-working-policies (CRUD JSON:API via schema condiviso).
